import eKukkaLogo from '../../images/ekukka.svg';
import userLogo from '../../images/user-08.svg';
import './header.css';
import React from 'react'
import { useEffect } from "react"
import {useLocation } from "react-router-dom";
import $ from 'jquery'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars} from '@fortawesome/free-solid-svg-icons'

const Header = props => {
  const location = useLocation()
  const path = location.pathname.split("/")[1];
  
  useEffect(() => {
      window.addEventListener('scroll', isSticky);
      return () => {
          window.removeEventListener('scroll', isSticky);
      };
  }, []);
       
  /* Method that will fix header after a specific scrollable */
  const isSticky = (e) => {
    //const header = document.querySelector('#header');
    var distanceFromTop = $(window).scrollTop();
    var distanceFromTopForA = $(window).scrollTop();
    if(distanceFromTop <= 0) {
      $('#header_bar').css('height', '100px');
      $('header nav li a').css('line-height', '80px');
      $('#header_bar #logo').css('margin-bottom', '15px');
      $('#no-login-icon').css('margin-top', '25px');
      //$('#header_bar #user_registration').css('margin-top', '15px');
      $('#menu_link').css('margin-top', '40px');
    } else if (distanceFromTop > 0 && distanceFromTop < 44) {
      distanceFromTop = 100-distanceFromTop;
      distanceFromTopForA = 80-distanceFromTop;
      //var width = distanceFromTop * 1.82;
      $('#header_bar').css('height', distanceFromTop+'px');
      $('header nav li a').css('line-height', distanceFromTopForA+'px');
      $('#header_bar #logo').css('height', (parseInt(distanceFromTop)*0.8)+'px');
      $('#header_bar #logo').css('margin-top', '15px');
      $('#no-login-icon').css('margin-top', '15px');
      $('#menu_link').css('margin-top', (parseInt(distanceFromTop)*0.4)+'px');
    } else {
      $('#header_bar').css('height', '57px');
      $('#header_bar #logo').css('height', '46px');
      $('#header_bar #logo').css('margin-top', '8px');
      $('#no-login-icon').css('margin-top', '3px');
      $('header nav li a').css('line-height', '37px');
      $('#menu_link').css('margin-top', '21px');
    }
    $('#logo').css('width', 2*($('#logo').height())+'px');
  };

  const toggleSideBar = (e) => {
    e.preventDefault();
    if ($('.nav_bar').css('display') === 'none') {
      // open
      $('.nav_bar').css('display', 'block');
      $('body').css('overflow', 'hidden');
      $('.app').css('background-color', 'rgba(192,192,192,0.3)');
    } else {
      // close
      $('.nav_bar').css('display', 'none');
      $('body').css('overflow', 'auto');
      $('.app').css('background-color', '#fff');
    }
  }

  const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const faBarsIcon = <FontAwesomeIcon id="menu_link" onClick={toggleSideBar} icon={faBars} size="2x"/>

  const getFirstCharacterOfUserFirstName = (userData) =>{
    let name = userData.UserAttributes[2].Value;
    let firstLetterOfName = name[0];
    $("#user_registration").html('<div class="user_logo circle">'+ firstLetterOfName.toUpperCase() +'</div>');
  }

  /* Auth user */
  let clientId = "4inkkk5uo5ef4foec6enqofo0v";
  let lastAuthUser = getCookie("CognitoIdentityServiceProvider."+ clientId +".LastAuthUser");
  let user = getCookie("CognitoIdentityServiceProvider."+ clientId +"."+ lastAuthUser +".userData");
  
  if (typeof user === "undefined" || user === "") {
    $("#user_registration").html('<img id="no-login-icon" className="user_logo" src="'+userLogo+'" alt="user" />');
  }else{
    const userData = JSON.parse(decodeURIComponent(user));
    getFirstCharacterOfUserFirstName(userData);
  }
  /* End: Auth user */

  return (
    <header>
      <div id="header_bar_wrapper">
        <div id="header_bar">
          {path === "profile" && faBarsIcon}
          <a id="platform_logo" href="https://ekukka.fi">
            <img id="logo" src={eKukkaLogo} alt="eKukka.fi - Suomen Suurin Kukkakauppa" />
          </a>
          <nav>
            <ul>
              <li className="menu_item">
                <a href="/#"><div id="user_registration"></div></a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}
export default Header;